import React from "react";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import Contact from "../Contact/Contact";
import "./Footer.scss";

function Footer() {
  return (
    <>
      <section className="sec-5  spacing">
        <div className="container">
          <div className="logo-wrap">
            <div className="">
              <Fade>
                <Link to="/">
                  WowWish<span>Momemts</span>
                </Link>
                <h6>
                  We organized your special events &
                  <b> Make it forever special.</b>
                </h6>
              </Fade>
            </div>
          </div>
          <div className="row">
            <Contact />
          </div>
        </div>
      </section>
      <footer className="footer-wrap">
        <div className="container">
          <div className="f-bottom">
            <div className="col-left">
              <p>© WowWishMoment 2023</p>
              <p>
                <span className="cambon_font">Design By:-</span>
                <Link to="https://techfreelancex.netlify.app/">
                  TechFreelanceX
                </Link>
              </p>
              <p>
                <Link className="animateLine" to="/private-policy">
                  Private Policy
                </Link>
              </p>
              <p>
                <Link className="animateLine" to="/frequently-asked-questions">
                  FAQs
                </Link>
              </p>
              <p>
                <Link className="animateLine" to="/terms-and-conditions">
                  Terms & Conditions
                </Link>
              </p>
            </div>
            <div className="col-right">
              <ul className="social-links">
                <li className="s-link">
                  <Link to="/absoluteLink">
                    <i className="fa-brands fa-instagram"></i>
                  </Link>
                </li>
                <li className="s-link">
                  <Link to="/absoluteLink">
                    <i className="fa-brands fa-youtube"></i>
                  </Link>
                </li>
                <li className="s-link">
                  <Link to="/absoluteLink">
                    <i className="fa-brands fa-twitter"></i>
                  </Link>
                </li>
                <li className="s-link">
                  <Link to="/absoluteLink">
                    <i className="fa-brands fa-facebook-f"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
